import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface FeatureSettings {
  barcode_scanner_enabled?: boolean;
  product_subscriptions_enabled?: boolean;
  booking_enabled?: boolean;
  ai_skin_consultant_enabled?: boolean;
  ai_skin_consultant_require_login?: boolean;
  ai_skin_consultant_rate_limit_minutes?: number;
}

export const useFeatureSettings = () => {
  return useQuery({
    queryKey: ['feature-settings'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('settings')
        .select('value')
        .eq('key', 'features')
        .maybeSingle();
      
      if (error) throw error;
      
      return data?.value as FeatureSettings || { 
        barcode_scanner_enabled: false, 
        product_subscriptions_enabled: false,
        booking_enabled: false,
        ai_skin_consultant_enabled: false,
        ai_skin_consultant_require_login: true,
        ai_skin_consultant_rate_limit_minutes: 10,
      };
    },
  });
};
